<template>
  <div class="auth-wrapper">
    <div class="auth-container">
      <slot name="auth-container"></slot>
    </div>
    <p class="copyright">
      版权所有：成都运荔枝科技有限公司 备案号：蜀ICP备19017829号-1
    </p>
  </div>
</template> 

<script>
export default {
};
</script>


<style lang="less" scoped>
.auth-wrapper {
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  height: 100vh;
  background: #f0f2f5;
  overflow: auto;
  header {
    margin-top: 20px;
    margin-left: 40px;
    img {
      height: 42px;
    }
  }
  .auth-container {
    position: relative;
    flex: 1;
  }
  .copyright {
    position: relative;
    text-align: center;
    width: 100%;
    margin: 10px 0 40px 0;
    font-size: 14px;
    color: #999999;
  }
}
</style>